const editPromotionLayout = (promotion) => {
  NGXCPageDesignerApp('promotion', {
    experienceId: App.Campaign.id,
    themeId:      App.Campaign.themeId,
    promotionId:  promotion.id,
    editorView:   'edit',
  });
};

export { editPromotionLayout };
